// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__rCIZI","signatureBlock":"Footer_signatureBlock__1pF0w","signature":"Footer_signature__1kh3V"};